export default "__VITE_ASSET__BPvhL8vV__"